export const redisApi = {
  topKeysWithLimit: '/clouddm/console/api/v1/datasource/special/redis/top_keys_with_limit'
};
